import { useEffect, useState } from "react";
import { Button, PageContainer } from "../../../components";
import { alunoApi, professoresApi } from "../../../services";
import AsyncSelect from "react-select/async";
import { Aluno, AlunoCurso } from "../../../models";
import Form from "../../../components/form/Form";
import Alert from "../../../helpers/Alert";
import dayjs from "dayjs";
import { openBase64Pdf } from "../../../functions";

type DataType = {
  aluno: Aluno;
  aluno_cursos: AlunoCurso[];
}

export default function ProfessoresAlunos() {
  const query = new URLSearchParams(window.location.search);
  const alunoId = query.get('aluno_id');

  const [aluno, setAluno] = useState<Aluno | undefined>(undefined);
  const [data, setData] = useState<DataType | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  async function searchStudentData(id: number) {
    setLoading(true);
    const { data: response, isError } = await professoresApi.getAlunoData({ aluno_id: id });
    setLoading(false);
    if (isError) return Alert.error(response.data.message || 'Erro ao buscar dados do aluno');
    setAluno(response.aluno);
    setData(response);
  }

  async function onPreviewContract(payload: any) {
    Alert.await('Gerando pre-visualização do contrato...');
    try {
      const { data } = await alunoApi.downloadPreview({ aluno_cursos: [payload] })
      Alert.close();
      openBase64Pdf(data);
    } catch (error) {
      console.log(error);
      Alert.error((error as any)?.message ?? 'Erro ao gerar pre-visualização do contrato. Tente novamente mais tarde.');
    }
  }

  useEffect(() => {
    if (alunoId) {
      searchStudentData(Number(alunoId));
    }
  }, [alunoId]);

  return (
    <PageContainer>
      <h1 className="text-3xl mb-10">Informações do aluno</h1>

      <Form onSubmit={() => aluno?.id && searchStudentData(aluno.id)} className="flex gap-10 justify-between">
        <AsyncSelect
          value={aluno ? { value: aluno.id, label: aluno.nome } : undefined}
          onChange={(value: any) => {
            setAluno({ id: value.value, nome: value.label } as any);
          }}
          className="w-full max-w-[400px]"
          loadOptions={async (q: any) => {
            const { data, isError } = await alunoApi.all({ like: ['nome', q] });
            if (isError) return [];
            return data.data.map((opt: any) => ({ value: opt.id, label: opt.nome }));
          }}
        />

        <Button
          className="bg-constancia text-white hover:bg-constancia/80 mb-1 col-span-2"
          type="submit"
        >
          Pesquisar
        </Button>
      </Form>

      <main>
        {loading ? <p>Carregando...</p> : data?.aluno_cursos?.length && (
          <div className="mt-10">
            <h2 className="text-2xl mb-4">INFO GERAIS:</h2>

            {data?.aluno_cursos.map((ac) => (
              <section key={ac.id}>
                <div className="mb-2 grid grid-cols-8 gap-3">
                  <div className="border rounded border-black px-2 col-span-2">
                    {ac.curso?.descricao}
                  </div>
                  <div className="border rounded border-black px-2">
                    {ac._data.dias_semana.split(' - ')[0].trim()}
                  </div>
                  <div className="border rounded border-black px-2">
                    {ac._data.dias_semana.split(' - ')[1].trim()}
                  </div>
                  <div className="border rounded border-black px-2">
                    {ac.planos[0].toUpperCase()}
                  </div>
                  <div className="border rounded border-black px-2 text-blue-500">
                    {dayjs(ac._data.data_inicio).format('DD/MM/YYYY')}
                  </div>
                  <div className="border rounded border-black px-2 text-red-500">
                    {dayjs(ac._data.data_fim).format('DD/MM/YYYY')}
                  </div>
                  <div className="border rounded border-black px-2 font-bold cursor-pointer" onClick={() => onPreviewContract(ac._data)}>
                    Visualizar Contrato
                  </div>
                </div>

                {!!ac.faltas?.length && <div className="px-5">
                  <h5 className="text-lg mb-1">Faltas:</h5>
                  <ul className="mb-5">
                    {ac.faltas.map(falta => (
                      <li key={falta.id} className="flex gap-3">
                        <div className="border rounded border-black px-2 max-w-[34px]">
                          ❌
                        </div>
                        <div className="border rounded border-black px-2">
                          {dayjs(falta.data).format('DD/MM/YYYY')}
                        </div>
                        <div className="border rounded border-black px-2 w-full">
                          {falta.observacao}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>}
              </section>
            ))}
          </div>
        )}
      </main>
    </PageContainer>
  );
}
